"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createActionItemElement = void 0;
const uuid_1 = require("uuid");
const jmrBuilder_1 = require("../jmrBuilder");
const slateTypes_1 = require("../types/slateTypes");
const metaUtil_1 = require("./metaUtil");
const createActionItemElement = (itemStatus, options) => {
    const { item, title, isGenerated } = options;
    if (item) {
        return {
            type: slateTypes_1.CustomElementType.ActionItem,
            id: item.id,
            artifactId: {
                type: slateTypes_1.ObjectType.Action,
                field: slateTypes_1.ObjectField.Object,
                id: item.id,
            },
            itemStatus,
            children: [
                (0, jmrBuilder_1.createField)('Start typing an action item...', item.title, false, false, {
                    type: slateTypes_1.ObjectType.Action,
                    field: slateTypes_1.ObjectField.Title,
                    id: item.id,
                }),
                (0, metaUtil_1.getActionItemMetaData)(item.id, { actionItem: item }),
            ],
        };
    }
    else {
        const newId = (0, uuid_1.v4)();
        const { defaultAssignee } = options;
        return {
            type: slateTypes_1.CustomElementType.ActionItem,
            id: newId,
            artifactId: {
                type: slateTypes_1.ObjectType.Action,
                field: slateTypes_1.ObjectField.Object,
                id: newId,
            },
            itemStatus,
            children: [
                (0, jmrBuilder_1.createField)('Start typing an action item...', title ? title : '', false, false, {
                    type: slateTypes_1.ObjectType.Action,
                    field: slateTypes_1.ObjectField.Title,
                    id: newId,
                }),
                (0, metaUtil_1.getActionItemMetaData)(newId, { defaultAssignee, isGenerated }),
            ],
        };
    }
};
exports.createActionItemElement = createActionItemElement;
